import { createSlot } from '@ayocore/platform/client/extensions/createSlot';
import type { ComponentType, ReactNode } from 'react';

/** Навигационная карточка на главной */
export interface WelcomeNavCard {
  key: string;
  label: string;
  icon: ComponentType<{ size?: number; stroke?: number; color?: string }>;
  url?: string;
  order?: number;
}

/** Блок статистики на главной */
export interface WelcomeStatBlock {
  /** Уникальный ключ (используется для localStorage toggle) */
  key: string;
  /** Заголовок блока (отображается в UI настроек) */
  label: string;
  /** Самодостаточный компонент блока */
  content: ReactNode;
  /** Порядок сортировки (по возрастанию) */
  order?: number;
  /** Ширина на десктопе в сетке из 12 колонок; по умолчанию 12. На телефоне — вся строка. */
  span?: number;
  /** Видимость до первого выбора пользователя; по умолчанию true. */
  defaultVisible?: boolean;
}

/**
 * Слоты расширения для WelcomePage.
 *
 * Модули регистрируют карточки и блоки в bootstrap.ts:
 * ```ts
 * WelcomeExtensions.navigationCards.register(() => ({
 *   key: 'my-card', label: 'Мой раздел', icon: IconStar, url: '/my', order: 10,
 * }));
 * WelcomeExtensions.statBlocks.register(() => ({
 *   key: 'my-stats', label: 'Моя статистика', content: <MyBlock />, order: 10,
 * }));
 * ```
 */
export const WelcomeExtensions = {
  /** Навигационные карточки */
  navigationCards: createSlot<void, WelcomeNavCard>(),
  /** Блоки статистики (handler может вернуть null для условного пропуска) */
  statBlocks: createSlot<void, WelcomeStatBlock | null>(),
};
